import React from "react";
import UserService from "../utilities/userService";
import Icon from "./icon/icon";
import NotificationCount from "./notifications/notificationCount";

export interface INotificationsCartProps {
  mobile: boolean;
  setNotificationsOpen: (value: boolean) => void;
  notificationCount: number;
  accountNumber?: string;
  customerAccountName?: string;
  cartNumberOfItems: number;
}

function NotificationsCart(props: INotificationsCartProps) {
  return (
    <>
      <div className="only-print account-info">
        {props.accountNumber}, {props.customerAccountName}
      </div>

      <div
        className={
          (props.mobile
            ? "notifications-cart-icons mobile no-print"
            : "notifications-cart-icons") +
          (UserService.displayUserInfo() ? "" : " disabled")
        }
        onClick={() => {
          if (UserService.displayUserInfo()) {
            props.setNotificationsOpen(true);
          }
        }}
      >
        <Icon
          className={
            "notifications-icon" +
            (props.mobile &&
            props.cartNumberOfItems &&
            props.cartNumberOfItems > 0
              ? " cart-has-items"
              : "")
          }
          tabIndex={0}
        >
          notifications
        </Icon>
        {UserService.displayUserInfo() && (
          <NotificationCount
            count={props.notificationCount}
            top={-6}
            left={-45}
          />
        )}
        <span className="notification-divider no-print"></span>
      </div>
    </>
  );
}

export default NotificationsCart;
